
const callRecaptchaToken = function(form){
  // let form = document.getElementById('_Form')
  if (form) {
    let formName = form.getAttribute('name')
    let functionName = `recaptchaCallback_${formName}_captcha`
    if (typeof window[functionName] === 'function') {
      window[functionName]()
    }
  }
}

window.callRecaptchaToken = callRecaptchaToken

document.addEventListener('DOMContentLoaded', () => {
  let $pop = document.querySelector(".b-feedback")
  // blink fixer
  setTimeout(() => {
    $pop.classList.remove('hide')
  }, 500);

  // let feedbackButton = document.getElementById('feedbackButton');
  let feedbackButtons = document.querySelectorAll('#feedbackButton, a[href="#feedback"]');

  feedbackButtons.forEach( (el, i) => {
    el.addEventListener('click', function (e) {
      $pop.classList.remove('offscreen')
      let body = document.querySelector('body')
      body.classList.add('grecaptcha-badge--show')
      let form = document.getElementById('_Form')
      callRecaptchaToken(form)
      // document.querySelector('body').classList.add('grecaptcha-badge--show');
      e.preventDefault();
    });
  })

  let feedbackCloseButton = document.querySelector('.b-feedback-up__close');

  feedbackCloseButton.addEventListener('click', function (e) {
    $pop.classList.add('offscreen')
    let body = document.querySelector('body')
    body.classList.remove('grecaptcha-badge--show')
    // document.querySelector('body').classList.remove('grecaptcha-badge--show');
    e.preventDefault();
  });

})